import { useEffect, useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { Box, Button, Flex, Header, Input, Loader, Message } from 'components';
import { IUserProfileFull } from 'common/entities';
import { handleAuthError } from 'common/handlers';
import { ApiProfile } from 'common/api';
import './style.scss';
import { AuthService } from 'common/services';
import { RoutingUrls } from 'common/const';

function CardProfile() {
  const [profile, setProfile] = useState<IUserProfileFull | null>(null);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    const profile = await handleAuthError(async () => await ApiProfile.getInstance().get());

    setProfile(profile);
  };

  const handleLogoutClick = () => {
    AuthService.getInstance().clear();
    window.location.assign(RoutingUrls.Auth);
  };

  return (
    <Box
      className='card-profile-mhYN'
      padding={20}
    >
      <Flex
        direction='column'
        gap={20}
      >
        <Header>Мой профиль</Header>

        {profile == null && (
          <Flex
            className='l-skoix'
            justifyContent='center'
            alignItems='center'
          >
            <Loader
              color='red'
              variant='line'
              size='default'
            />
          </Flex>
        )}

        {profile != null && (
          <>
            <Message type='info'>Данные вашего профиля, указанные при первом входе в аккаунт.</Message>

            <Flex direction='column'>
              <Input
                type='text'
                icon={<bi.Envelope />}
                label='Адрес электронной почты'
                readonly
                value={profile.email}
              />

              <Input
                type='text'
                icon={<bi.Phone />}
                label='Номер телефона'
                readonly
                value={profile.phone}
              />
            </Flex>

            <Button
              color='red'
              onClick={handleLogoutClick}
            >
              <Flex
                justifyContent='center'
                alignItems='center'
                gap={5}
              >
                <bi.DoorOpen />
                <div>Выйти из аккаунта</div>
              </Flex>
            </Button>
          </>
        )}
      </Flex>
    </Box>
  );
}

export default CardProfile;
